import { render, staticRenderFns } from "./blockZkn.vue?vue&type=template&id=47c29db2&scoped=true"
import script from "./blockZkn.vue?vue&type=script&lang=js"
export * from "./blockZkn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47c29db2",
  null
  
)

export default component.exports